// Пересортировка строк админских таблиц (TableDnD).
// Подключается ко всем <table class="table-dnd">, настройка — data-атрибутами:
//
//   data-dnd-url              — endpoint сохранения порядка (обязательно)
//   data-dnd-mode             — "flat" (по умолчанию) или "tree"
//   data-dnd-handle           — селектор ручки перетаскивания (по умолчанию ".table-dnd-handle")
//   data-dnd-id               — атрибут логического id строки (по умолчанию "data-id")
//   data-dnd-parent           — атрибут id родителя, режим tree (по умолчанию "data-parent")
//   data-dnd-depth            — атрибут глубины вложенности, режим tree (по умолчанию "data-depth")
//   data-dnd-dragging-class   — класс строки во время переноса (по умолчанию "table-dnd-dragging")
//
// Требования к строкам: уникальный id <tr> (детект изменений TableDnD) и атрибут data-dnd-id.
//
// flat: переставляются все строки, POST { order: [id, …] }.
// tree: поддерево (строка + все потомки) уходит одним блоком, дроп разрешён только
//       среди сестёр (тот же parent) — смена родителя запрещена,
//       POST { parent_id, order: [id сестёр, …] }.

require("tablednd"); // плагин jQuery: $.fn.tableDnD

jQuery(document).ready(function () {
    jQuery("table.table-dnd").each(function () {
        initTableDnD(this);
    });
});

/**
 * Инициализация пересортировки одной таблицы.
 *
 * @param {HTMLTableElement} tableEl
 */
function initTableDnD(tableEl) {
    let table = jQuery(tableEl);
    let cfg = {
        url: table.attr("data-dnd-url"),
        mode: table.attr("data-dnd-mode") || "flat",
        handle: table.attr("data-dnd-handle") || ".table-dnd-handle",
        idAttr: table.attr("data-dnd-id") || "data-id",
        parentAttr: table.attr("data-dnd-parent") || "data-parent",
        depthAttr: table.attr("data-dnd-depth") || "data-depth",
        draggingClass: table.attr("data-dnd-dragging-class") || "table-dnd-dragging"
    };

    let tbody = tableEl.tBodies[0];

    if (!cfg.url || !tbody) {
        return;
    }

    let state = null; // { block: [tr, …], observer: MutationObserver|null } — на время одного перетаскивания

    function rowId(row) {
        return Number(jQuery(row).attr(cfg.idAttr));
    }

    function rowParent(row) {
        return jQuery(row).attr(cfg.parentAttr);
    }

    function rowDepth(row) {
        return Number(jQuery(row).attr(cfg.depthAttr));
    }

    // flat — сама строка; tree — строка + все последующие с бóльшей глубиной (поддерево).
    function blockOf(row) {
        let block = [row];

        if (cfg.mode !== "tree") {
            return block;
        }

        let depth = rowDepth(row);
        let next = row.nextElementSibling;

        while (next) {
            if (rowDepth(next) <= depth) {
                break;
            }
            block.push(next);
            next = next.nextElementSibling;
        }

        return block;
    }

    // Держим блок вместе: после каждого перемещения родителя плагином
    // вешаем потомков сразу за ним, в исходном порядке.
    function keepBlockTogether() {
        if (state === null) {
            return;
        }

        let parentRow = state.block[0];
        let children = state.block.slice(1);

        if (children.length === 0 || parentRow.nextElementSibling === children[0]) {
            return;
        }

        let anchor = parentRow;

        children.forEach(function (child) {
            anchor.after(child);
            anchor = child;
        });
    }

    function cleanup() {
        if (state === null) {
            return;
        }

        if (state.observer) {
            state.observer.disconnect();
        }

        state.block.forEach(function (row) {
            jQuery(row).removeClass("nodrop");
        });

        state = null;
    }

    function allowDrop(draggedRow, targetRow) {
        let dragged = jQuery(draggedRow);
        let target = jQuery(targetRow);

        if (dragged.attr("id") === target.attr("id")) {
            return false;
        }
        if (cfg.mode !== "tree") {
            return true;
        }

        // Только сёстры (тот же родитель) — смена родителя запрещена.
        return rowParent(draggedRow) === rowParent(targetRow);
    }

    // Новые id в порядке DOM: tree — сёстры перетаскиваемой (тот же parent), flat — все строки.
    function orderedIds(draggedRow) {
        let ids = [];

        if (cfg.mode === "tree") {
            let parentId = rowParent(draggedRow);

            for (let i = 0; i < tbody.rows.length; i++) {
                if (rowParent(tbody.rows[i]) === parentId) {
                    ids.push(rowId(tbody.rows[i]));
                }
            }
        } else {
            for (let i = 0; i < tbody.rows.length; i++) {
                ids.push(rowId(tbody.rows[i]));
            }
        }

        return ids;
    }

    function onDrop(tableEl, row) {
        let ids = orderedIds(row);
        let payload = { order: ids };

        if (cfg.mode === "tree") {
            payload.parent_id = Number(rowParent(row));
        }

        cleanup();

        if (ids.length === 0) {
            return;
        }

        jQuery.post(cfg.url, payload)
            .done(function (response) {
                if (response && response.message) {
                    window.showToast(response.message, "success");
                }
            })
            .fail(function (xhr) {
                let message = "Не удалось сохранить порядок";

                if (xhr && xhr.responseJSON && xhr.responseJSON.message) {
                    message = xhr.responseJSON.message;
                }

                window.showToast(message, "danger");
            });
    }

    table.tableDnD({
        dragHandle: cfg.handle,
        onDragClass: cfg.draggingClass,
        onDragStart: function (tableEl, handle) {
            let row = jQuery(handle).parents("tr")[0];
            let block = blockOf(row);

            state = { block: block, observer: null };

            if (cfg.mode === "tree") {
                // Потомки блока — не цели для дропа (блок уходит целиком).
                block.slice(1).forEach(function (child) {
                    jQuery(child).addClass("nodrop");
                });

                state.observer = new MutationObserver(keepBlockTogether);
                state.observer.observe(tbody, { childList: true });
            }
        },
        onAllowDrop: allowDrop,
        onDrop: onDrop,
        onDragStop: function () {
            // onDrop уже сделал cleanup (если порядок изменился);
            // иначе (отмена/возврат на место) чистим здесь.
            cleanup();
        }
    });
}
